import { Image, Section } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledSection = styled(Section)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 0 1rem;

  @media (min-width: ${(props) => props.theme.media.md}) {
    flex-direction: row;
    padding: 0;
  }
`;

export const ImageWrapper = styled.div`
  margin-bottom: 1rem;
  text-align: center;

  @media (min-width: ${(props) => props.theme.media.md}) {
    margin-bottom: 0;
    margin-right: 3.75rem;
  }
`;

export const TextWrapper = styled.div`
  text-align: center;

  @media (min-width: ${(props) => props.theme.media.md}) {
    max-width: 40rem;
    text-align: left;
  }
`;

export const AwardImage = styled(Image)`
  display: block;
`;
